import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"

import {getSentimentById} from "../../../helpers/Sentiment"
import {Image} from "../../../ui/Image"

const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const SentimentCellRenderer = ({row, ...props}) => {
  const idNamespace = id("SentimentCellRenderer", props)
  const sentimentObject = row.tags && row.tags.find((tag) => tag.type === "sentiment")
  let sentiment = "--"
  if (sentimentObject) sentiment = sentimentObject.data.sentiment

  return (
    <Cell id={idNamespace}>
      {sentimentObject ? <Image src={getSentimentById(sentiment).icon} alt="" size={29} /> : sentiment}
    </Cell>
  )
}

SentimentCellRenderer.propTypes = {
  row: PropTypes.any
}

SentimentCellRenderer.defaultProps = {
  row: {tags: []}
}

export default SentimentCellRenderer
